// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"style_mainDiv__2rTz8","copyrightLine":"style_copyrightLine__Sm_Cj"};